import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "rowValue" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "«", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "»", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("table", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.container.rows, (field, index) => {
        return (_openBlock(), _createBlock("tr", {
          key: field,
          class: { 'hide-row' : (index > 8 && _ctx.showMoreOption) ? true : false }
        }, [
          _createVNode("td", _hoisted_2, _toDisplayString(field.title), 1),
          _createVNode("td", _hoisted_3, [
            _createVNode("span", {
              innerHTML: _ctx.getFieldByKey(field.key)
            }, null, 8, ["innerHTML"])
          ])
        ], 2))
      }), 128))
    ]),
    _withDirectives(_createVNode("label", {
      class: "show-more",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleShowMore()))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("default.button.show_more")) + " ", 1),
      _hoisted_4
    ], 512), [
      [_vShow, _ctx.canShowMoreOption && _ctx.showMoreOption]
    ]),
    _withDirectives(_createVNode("label", {
      class: "show-more",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleShowMore()))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("default.button.show_less")) + " ", 1),
      _hoisted_5
    ], 512), [
      [_vShow, _ctx.canShowMoreOption && !_ctx.showMoreOption]
    ])
  ]))
}